const navbars = document.querySelectorAll('[data-navbar-wrapper]')

navbars.forEach(navbar => {
  const toggle = navbar.querySelector('[data-navbar-toggle]')

  toggle.addEventListener('click', function () {
    navbar.classList.toggle('open')
  })
})
